export default __webpack_public_path__ + "static/media/logo.3747bd8f.svg";